export default class CustomMessages {
    static USER_REGISTERED_SUCCESSFULLY= "Your registration is complete! Thanks for joining us and we can't wait to see you around!"
    static INCORRECT_OTP="You entered incorrect OTP!"
  }
  